import React, { FC, useMemo } from 'react';
import { useFlatfile, Space, Workbook, Sheet, useEvent } from '@flatfile/react';
import { Flatfile } from '@flatfile/api';
import { submitData, WORK_BOOK_SUBMIT_ACTION } from './faltfile_utils';

const FlatfileButton: FC<any> = ({
	type,
	fields,
	onDataLoad,
	recordHook,
	onCancel,
	renderElement,
	mappingConfidenceThreshold,
	validateRecordsOnSubmit,
}): React.ReactElement => {
	const { openPortal, closePortal } = useFlatfile({
		onClose: () => {
			onCancel && onCancel();
		},
	});

	useEvent('job:ready', { job: 'workbook:submitAction' }, async (event) => {
		await submitData(event, onDataLoad, closePortal, validateRecordsOnSubmit);
	});

	const sheetConfig = useMemo(
		() => ({
			name: type,
			slug: type,
			fields,
			...(mappingConfidenceThreshold && { mappingConfidenceThreshold }),
		}),
		[fields, mappingConfidenceThreshold, type]
	);

	const workbook = useMemo(
		() => ({
			name: 'All Data',
			labels: ['pinned'],
			sheets: [sheetConfig],
			actions: [WORK_BOOK_SUBMIT_ACTION],
		}),
		[sheetConfig]
	);

	return (
		<>
			{renderElement(openPortal)}
			<Space
				config={{
					metadata: {
						sidebarConfig: {
							showSidebar: false,
						},
					},
				}}
			>
				<Workbook
					config={workbook as Flatfile.workbooks.CreateWorkbookConfig}
					onRecordHooks={[
						[
							type,
							(record) => {
								return recordHook ? recordHook(record) : record;
							},
						],
					]}
				>
					<Sheet config={sheetConfig} />
				</Workbook>
			</Space>
		</>
	);
};

export default FlatfileButton;
